import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "./SelectedLandingPage.module.scss";

type SelectedLandingPageProps = {
  selectedLandingPage: string;
};

const SelectedLandingPage: FC<SelectedLandingPageProps> = ({ selectedLandingPage }) => {
  return (
    <div className={classes.container}>
      <Typography className={classes.selectedLandingPage}>
        Destination Page:{" "}
        {selectedLandingPage ? (
          <a
            href={selectedLandingPage.startsWith("http") ? selectedLandingPage : `http://${selectedLandingPage}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {selectedLandingPage}
          </a>
        ) : (
          <span>None</span>
        )}
      </Typography>
    </div>
  );
};

export default SelectedLandingPage;
